
<template>
  <!--设备运行日志-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="log_info_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'devRunLog',
  data () {
    return {
      searchList: [
        { props: ['community_id'], placeholder: '小区名称', options: [], inputType: 'select' },
        { props: ['device_id'], placeholder: '设备ID', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '类型', options: [], inputType: 'select' },
        { props: ['device_no'], placeholder: '设备编码', options: [], inputType: 'input' }
      ],
      tableOptList: [],
      rowOptList: [],
      columns: [
        { title: '记录时间', dataIndex: 'log_time', align: 'left', width: '' },
        { title: '所在小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '通行门', dataIndex: 'position_name', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'device_title', align: 'left', width: '' },
        { title: '设备编码', dataIndex: 'device_no', align: 'left', width: '' },
        { title: '类型', dataIndex: 'type_desc', align: 'left', width: '' },
        { title: '内容', dataIndex: 'content', align: 'left', width: '' }
      ],
      dataSource: [],
      searchParams: {
        community_id: undefined,
        device_id: undefined,
        type: undefined,
        device_no: undefined
      },
      listApi: {
        url: '/black_device_log',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {}
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.communitySelect(0, 'searchList', 1);
      this.typeSelect({
        query: 'black_log_type',
        scope: 'searchList',
        index: 2
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
